import { z, ZodType } from 'zod';
import { Player, playerSchema } from './player';

export type Device = {
	id: number;
	players: Player[];
	name: string;
	externalDeviceId: string;
	cashdeskCode: string;
	isActive: boolean;
};

export const deviceSchema: ZodType<Device> = z.object({
	id: z.number(),
	players: z.array(playerSchema),
	name: z.string(),
	externalDeviceId: z.string(),
	cashdeskCode: z.string(),
	isActive: z.boolean(),
});
